import React, { PureComponent } from 'react';
import { bool, string, shape, arrayOf, number, func } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { reduxForm } from 'redux-form';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton } from '@widergy/energy-ui';

import { ROUTES } from 'constants/routes';

import { actionCreators as accountActions } from '../../../../../redux/accountHandlers';
import AuthFormBox from '../../../../components/AuthFormBox';
import { message } from '../../../../../utils/stringUtils';
import { SIGNUP_RELATED_ACCOUNTS } from '../../../../../constants/reduxForms';
import ReturnToSignIn from '../ReturnToSignIn';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import RelatedAccounts from './layout';
import styles from './styles';

class RelatedAccountsContainer extends PureComponent {
  componentDidMount = () => {
    this.props.dispatch(accountActions.getRelatedAccounts(this.props.initialAccount, true));
    gaTrackPageView(ROUTES.SIGN_UP);
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.relatedAccountsLoading &&
      !nextProps.relatedAccountsLoading &&
      nextProps.relatedAccounts &&
      nextProps.relatedAccounts.length === 0
    ) {
      this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
    }
  }

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit}
        onKeyDown={handleKeyDown(this.props.handleSubmit)}
        style={styles.container}
      >
        <AuthFormBox title={message('Signup:addYourAccounts')}>
          <RelatedAccounts
            loading={this.props.relatedAccountsLoading || this.props.addAccountLoading}
            relatedAccounts={this.props.relatedAccounts}
          />
        </AuthFormBox>
        {!this.props.relatedAccountsLoading && !this.props.addAccountLoading && (
          <React.Fragment>
            <UTButton
              disabled={this.props.submitFailed && this.props.invalid}
              style={styles.submit}
              type="submit"
            >
              {message('Signup:next')}
            </UTButton>
            <ReturnToSignIn key="signout" />
          </React.Fragment>
        )}
      </form>
    );
  }
}

RelatedAccountsContainer.propTypes = {
  relatedAccountsLoading: bool,
  addAccountLoading: bool,
  relatedAccounts: arrayOf(
    shape({
      id: number,
      address: string,
      client_number: string
    })
  ),
  initialAccount: string,
  handleSubmit: func.isRequired,
  submitFailed: bool,
  invalid: bool
};

const mapStateToProps = store => ({
  relatedAccounts: store.account.relatedAccounts,
  relatedAccountsLoading: store.account.relatedAccountLoading,
  addAccountLoading: store.account.addAccountLoading,
  initialAccount: store.auth.signUpFlow.initialAccount
});

const form = reduxForm({ form: SIGNUP_RELATED_ACCOUNTS })(RelatedAccountsContainer);

export default connect(mapStateToProps)(form);
